/**
 * Employee Web — `/auth/forgot` route.
 *
 * UNAUTHENTICATED. AUTH-09: the UI renders an identical "check your email"
 * confirmation regardless of whether the email was registered (enumeration
 * defense). The ResetRequestForm owns that local-state transition.
 */
import type { JSX } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ForgotPage } from "../features/auth/ForgotPage";

export const Route = createFileRoute("/auth/forgot")({
  component: ForgotRouteComponent,
});

function ForgotRouteComponent(): JSX.Element {
  const navigate = useNavigate();
  return (
    <ForgotPage
      onBack={() => {
        void navigate({ to: "/login" });
      }}
    />
  );
}
